const services = [
  {
    num: '01',
    title: 'Diseño Arquitectónico',
    desc: 'Proyecto arquitectónico integral, desde la conceptualización hasta la documentación ejecutiva.',
    highlight: true,
  },
  {
    num: '02',
    title: 'Diseño',
    desc: 'Interiores, fachadas, remodelaciones y selección de materiales.',
    highlight: false,
  },
  {
    num: '03',
    title: 'Gestión y documentación',
    desc: 'Elaboración de proyecto ejecutivo y planos para trámite municipal. Gestión de permisos y licencias (apoyo en el proceso).',
    highlight: false,
  },
  {
    num: '04',
    title: 'Construcción',
    desc: 'Ejecución de obra, supervisión y coordinación de proveedores.',
    highlight: false,
  },
];

export default function Services() {
  return (
    <section id="servicios" className="bg-neutral-50 text-neutral-900 scroll-mt-20">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="mb-14 md:mb-20 reveal">
          <p className="overline text-neutral-400">Servicios</p>
          <h2 className="font-display font-medium tracking-tightest text-[clamp(2rem,5vw,4.5rem)] mt-4 max-w-3xl">
            Del primer boceto a la obra terminada
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-neutral-200 border border-neutral-200">
          {services.map((s) => (
            <div
              key={s.num}
              className={`group p-8 md:p-12 flex flex-col gap-6 transition-colors duration-500 reveal ${
                s.highlight
                  ? 'bg-neutral-900 text-white'
                  : 'bg-white text-neutral-900 hover:bg-neutral-100'
              }`}
            >
              <div className="flex items-start justify-between">
                <span
                  className={`overline ${
                    s.highlight ? 'text-white/50' : 'text-neutral-300'
                  }`}
                >
                  {s.num}
                </span>
                {s.highlight && (
                  <span className="overline text-white/60 border border-white/30 px-3 py-1">
                    Servicio principal
                  </span>
                )}
              </div>
              <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tightest leading-tight">
                {s.title}
              </h3>
              <p
                className={`text-base leading-relaxed ${
                  s.highlight ? 'text-white/70' : 'text-neutral-500'
                }`}
              >
                {s.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-16 reveal">
          <a
            href="#contacto"
            className="whitespace-nowrap inline-flex items-center justify-center px-8 py-4 text-xs font-medium uppercase tracking-[0.18em] bg-neutral-900 text-white hover:bg-neutral-700 transition-colors"
          >
            Quiero cotizar mi proyecto
          </a>
        </div>
      </div>
    </section>
  );
}